import { i18n, MessageDescriptor, Messages } from '@lingui/core';
import { defineMessage } from '@lingui/core/macro';
import { LanguageEnum, LanguageEnumRuntype } from '@luminovo/commons';

export type LocaleConfig = {
    locale: LanguageEnum;
    messages: Messages;
};

export const languageTranslations: Record<LanguageEnum, MessageDescriptor> = {
    en: defineMessage({ message: 'English' }),
    de: defineMessage({ message: 'German' }),
    fr: defineMessage({ message: 'French' }),
    es: defineMessage({ message: 'Spanish' }),
    it: defineMessage({ message: 'Italian' }),
    th: defineMessage({ message: 'Thai' }),
    zh: defineMessage({ message: 'Chinese' }),
    ja: defineMessage({ message: 'Japanese' }),
    hi: defineMessage({ message: 'Hindi' }),
    cs: defineMessage({ message: 'Czech' }),
    nl: defineMessage({ message: 'Dutch' }),
    hu: defineMessage({ message: 'Hungarian' }),
    pt: defineMessage({ message: 'Portuguese' }),
    fi: defineMessage({ message: 'Finnish' }),
    sv: defineMessage({ message: 'Swedish' }),
    pl: defineMessage({ message: 'Polish' }),
    tr: defineMessage({ message: 'Turkish' }),
};

export function detectLocale(): string {
    // The user's preferred language first, then the browser UI's.
    if (navigator.languages && Array.isArray(navigator.languages) && navigator.languages[0]) {
        return navigator.languages[0];
    }

    if (typeof navigator.language === 'string') {
        return navigator.language;
    }
    return 'en';
}

export function determineLanguageEnum(anyLocaleString: string): LanguageEnum {
    const parsed = LanguageEnumRuntype.safeParse(anyLocaleString);
    return parsed.success ? parsed.data : 'en';
}

export const getLocale: () => LanguageEnum = () => determineLanguageEnum(i18n.locale);

export const isGermanLocale: () => boolean = () => getLocale() === 'de';

export const detectLanguageEnum: () => LanguageEnum = () => determineLanguageEnum(detectLocale());
